import FluxUtils from 'flux/utils';
import { History, Location } from 'history';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import SettingsStore from 'sharedreact/stores/SettingsStore';
import UrlQuery from 'sharedreact/utils/UrlQuery';
import { assertNonNullish } from 'sharedreact/utils/TypeSupport';

import AdminPage from 'workspaces/launcher/components/admin/AdminPage';
import ServerInfoStore from 'workspaces/launcher/stores/ServerInfoStore';
import asFunctional from 'sharedreact/components/asFunctional';
import LocationState from 'sharedreact/utils/LocationState';
import { StaticContext } from 'react-router';

function handleSelectTab (tab: string, history: History<LocationState>, location: Location<LocationState>): void {
  let search: {[key: string]: string} = UrlQuery.parse(location.search);
  search.tab = tab;

  const searchString: string = UrlQuery.stringify(search);

  history.replace(location.pathname + searchString);
}

type Props = RouteComponentProps<{}, StaticContext, LocationState> & {
};

type State = ConstructorParameters<typeof AdminPage>[0];

function getStores () {
  return [
    SettingsStore,
    ServerInfoStore
  ];
}

function calculateState (prevState?: State, props?: Props): State {
  assertNonNullish(props);

  const search: {[key: string]: string} = UrlQuery.parse(props.location.search);
  const tab: string = search.tab || '';
  const action: string = search.action || '';
  const id: string = search.id || '';

  return {
    activeTab: tab,
    action: action,
    userId: id,
    language: SettingsStore.getLanguage(),
    canManageAgents: ServerInfoStore.canManageAgents(),
    canManageTokens: ServerInfoStore.canManageTokens(),
    onSelectTab: (tab) => handleSelectTab(tab, props.history, props.location)
  };
}

export default withRouter(
  FluxUtils.Container.createFunctional(
    asFunctional(AdminPage),
    getStores,
    calculateState,
    { withProps: true }
  )
);
